import { EPage } from '@types';

export const FATAL_ERROR_CODE = 500;

export const PAGE_OFFSETS: Record<EPage, number> = {
  [EPage.CART]: 10.5625,
  [EPage.UPSELLING]: 4.6875,
  [EPage.DELIVERY_AND_PAYMENT]: 4.6875,
  [EPage.RESERVATION]: 10.5625,
  [EPage.RESERVATION_PAYMENT_AND_DELIVERY]: 4.6875,
  [EPage.HOME_PAGE]: 0,
  [EPage.CART_LOG_IN]: 4.6875,
  [EPage.PAYMENT_AND_DELIVERY]: 4.6875,
  [EPage.THANK_YOU]: 4.6875,
  [EPage.SUMMARY]: 4.6875,
  [EPage.REPAY]: 4.6875,
  [EPage.LOGIN_PAGE]: 0,
  [EPage.REGISTER_PAGE]: 0,
  [EPage.BENEFITS_PAGE]: 0,
  [EPage.DISCOVERY_BOX]: 0,
  [EPage.ADYEN_PAYMENT_REDIRECT_PAGE]: 4.6875,
  [EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE]: 4.6875,
  [EPage.GOPAY_PAYMENT_REDIRECT_PAGE]: 4.6875,
  [EPage.LOYALTY_PROGRAM]: 0,
  [EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE]: 4.6875,
};
